import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/users/")({
  staticData: {
    title: "users.title",
  },
});
